module.exports = __webpack_public_path__ + "assets/img/dialog-bg.bcc6e5c3.png";